var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconCheck = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M19.2803 6.96979C18.9878 6.67654 18.513 6.67654 18.2198 6.96904L9.74325 15.4388L5.781 11.4698C5.4885 11.1765 5.01375 11.1765 4.7205 11.469C4.42725 11.7615 4.42725 12.2363 4.71975 12.5295L9.21225 17.0295C9.249 17.0663 9.288 17.0985 9.33 17.1255C9.61575 17.3145 10.0028 17.2868 10.2593 17.043C10.2638 17.0385 10.2683 17.034 10.2728 17.0295L10.275 17.0273L19.2803 8.02954C19.5735 7.73704 19.5735 7.26154 19.281 6.96904L19.2803 6.96979Z", fill: "black" }))),
        alt: 'Check',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconCheck;
//# sourceMappingURL=index.js.map